<template>
  <div :class="formGroupClass">
    <div class="input-group input-group-sm mb-3">
      <slot name="before"/>
      <label for="form-subject-type" class="control-label">{{ inputLabel }}</label>
      <div style="display: flex">
        <slot name="selectNationality"></slot>
        <select
          id="form-subject-type"
          class="form-control subject-input-select"
          v-model="inputValue"
          @change="emit($event)"
          @input="emit($event)"
          :disabled="disabled"
          :title="selectedSubject.name"
        >
          <option
            v-for="subject in nationalitySubjects"
            v-bind:key="subject.id"
            :value="subject.id"
          >{{ subject.name }}
          </option>
        </select>
      </div>
      <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
      <slot name="after"/>
    </div>
  </div>
</template>

<script>
import applicationInputMixin from '@/common/mixins/applicationInputMixin'
import applicationFormMixin from '@/common/mixins/applicationFormMixin'
import organizationSectionMixin from '@/common/mixins/application-form/organizationSectionMixin'
import organizationInputMixin from '@/common/mixins/application-form/organizationInputMixin'

export default {
  name: 'OrganizationSubjectInput',

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    organizationSectionMixin,
    organizationInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Субъект права'
    },

    inputName: {
      default: 'subject_id'
    },

    items: {
      type: [Array],
      default: () => []
    },

    disabled: {
      default: false,
      type: Boolean
    },

    selectedNationality: {
      default: () => ({}),
      type: Object
    },

    organizationSubjectsResidency: {
      default: []
    },

    modelValue: String
  },

  computed: {
    nationalitySubjects() {
      if (this.isView) {
        return this.items
      }

      const subjectsId = [
        ...new Set(
          this.organizationSubjectsResidency
            .filter((value) => Number(value.nationality_id) === this.selectedNationality.id)
            ?.map((value) => value.subject_id)
        )
      ]

      return this.items.filter((subject) => subjectsId.includes(subject.id))
    },

    selectedSubject() {
      return this.items.find((subject) => subject.id === this.inputValue)
    }
  }
}
</script>
